const SUPPORT_EMAIL = "atencionclientes@allariafondos.com.ar";

export const falFundSelectionCopy = {
  title: "Fondos de Asistencia Laboral",
  subtitle: (holder: string) =>
    holder
      ? `Elegí la cartera FAL para la cuenta cuotapartista de ${holder}`
      : "Elegí la cartera FAL para tu cuenta cuotapartista",
  expectedYield: "Rendimiento esperado",
  ratesAsOf: (date: string) => `TNA al ${date}`,
  duration: "Duration de cartera",
  years: "años",
  choose: "Elegir este fondo",
  disclaimer: (date: string) =>
    `TNA al ${date}. Cifras estimadas de carácter ilustrativo; no constituyen promesa ni garantía de rendimiento futuro.`,

  confirmation: {
    title: "Confirmar elección",
    chose: "Elegiste",
    forAccount: "para la cuenta cuotapartista de",
    acceptance: "En mi carácter de titular de la cuenta, elijo el fondo",
    andAccept: "y acepto su",
    regulation: "reglamento de gestión",
    confirm: "Continuar",
    back: "Volver",
  },

  feedback: {
    success: {
      title: "Registramos tu elección",
      description: (fund: string, holder: string) => [
        holder
          ? `La cuenta cuotapartista de ${holder} quedó asociada a ${fund}.`
          : `Tu cuenta cuotapartista quedó asociada a ${fund}.`,
        "Una vez que la CNV defina los últimos aspectos operativos, te informaremos tu ID FAL.",
      ],
    },
    alreadyChosen: {
      title: "Ya registramos tu elección",
      description: (fund: string, date: string) => [
        date ? `Elegiste ${fund} el ${date}.` : `Elegiste ${fund}.`,
        "Si necesitás cambiarla, comunicate con tu asesor.",
      ],
    },
    notRegistered: {
      title: "No encontramos tu solicitud",
      description: [
        "No pudimos asociar este enlace a una solicitud de cuenta FAL.",
        `Escribinos a ${SUPPORT_EMAIL} y te ayudamos a completar tu elección.`,
      ],
    },
    invalidLink: {
      title: "Este enlace no es válido",
      description: [
        "Revisá que hayas abierto el enlace completo del mail.",
        `Si necesitás ayuda, escribinos a ${SUPPORT_EMAIL}.`,
      ],
    },
    genericError: {
      title: "No pudimos procesar tu solicitud",
      description: [
        "Probá de nuevo en unos minutos.",
        `Si el error persiste, escribinos a ${SUPPORT_EMAIL}.`,
      ],
    },
    retry: "Reintentar",
  },
};
